<template>
    <div>
        <message-controller></message-controller>
        <navbar></navbar>

        <div class="container pt-4">
            <h1 class="title">
                <span>Docházka&nbsp;<b-icon @click="layoutExt = !layoutExt" class="clickable" icon="list-check" variant="info"></b-icon></span>
                <b-icon @click="addNewSheet()" class="clickable" icon="plus-square-fill" variant="info"></b-icon>
            </h1>

            <table v-if="posts.courses && !layoutExt" class="table">
                <tbody>
                <tr v-for="item in posts.courses" v-bind:key="item.id">
                    <td style="width: 80px">
                        <span v-if="item.date">
                            {{ item.date.date | moment("DD/MM/YY") }}
                        </span>
                    </td>
                    <td>
                        <span>{{item.name}}</span>
                        <span v-if="item.name_custom"> - {{item.name_custom}}</span>
                    </td>
                    <td class="d-none d-md-block">
                        <span class="description">{{item.description}}</span>
                    </td>
                    <td>
                        <div class="icons">
                            <b-icon @click="openModal(item.id)"
                                    class="clickable" icon="pencil-square" variant="info"></b-icon>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <table v-else-if="posts.courses && layoutExt" class="table">
                <tbody>
                    <template v-for="item in posts.courses">
                        <tr  v-bind:key="item.id">
                            <td style="width: 80px">
                                <span v-if="item.date">
                                    {{ item.date.date | moment("DD/MM/YY") }}
                                </span>
                            </td>
                            <td>
                                <span>{{item.name}}</span>
                                <span v-if="item.name_custom"> - {{item.name_custom}}</span>
                            </td>
                            <td>
                                <span class="description">{{item.description}}</span>
                            </td>

                        </tr>
                        <tr class="no-border-row" v-bind:key="item.id + 10000">
                            <td colspan="2">
                                <ul>
                                    <li v-for="user in item.users" :key="user.id">
                                        {{user.name}}
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li v-for="student in item.students" :key="student.id">
                                        {{student.name}}
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <b-modal id="modal-edit" class="modal" hide-header >
            <div class="d-block" >
                <h3 class="item-wrap">
                    <span></span>
                </h3>
            </div>
            <div class="d-block" >
                <label>Druh akce</label><br>
                <b-form-radio-group
                        class="mb-3 courses-radio-btn"
                        v-model="modalData.id_courses"
                        :options="modalOptions.courses"
                        name="radio-options"
                        buttons
                        button-variant="info"
                        size="sm"
                        @change="updateModalData('reload-options')"
                ></b-form-radio-group>
                <b-form-input
                        v-model="modalData.name_custom"
                        type="text"
                        placeholder="Vypňte pokud akce není pravidelná"
                        @change="updateModalData()"
                ></b-form-input>
            </div>
            <hr>
            <div class="d-block" v-if="modalData.date">
                <label>Datum</label>
                <b-form-datepicker v-model="modalData.date.date"
                                   @input="updateModalData()"
                                   locale="cs"
                                   start-weekday="1"
                                   class="mb-2"></b-form-datepicker>
            </div>
            <hr>
            <div class="d-block" >
                <label>Časová dotace</label><br>
                <b-time v-model="modalData.time"
                        hide-header
                        @input="updateModalData()"></b-time>
            </div>
            <hr>
            <div class="d-block" >
                <label>Lektoři</label>
                <b-form-checkbox-group v-model="modalData.usersSelected"
                                       name="teachers-options"
                                       :options="modalOptions.users"
                                       stacked
                                       size="lg"
                                       @change="updateModalData()">
                </b-form-checkbox-group>
            </div>
            <hr>
            <div class="d-block" >
                <label>Studenti</label>
                <b-form-checkbox-group
                        v-if="modalData.id_courses"
                        class="students-group"
                        v-model="modalData.studentsSelected"
                        name="students-options"
                        :options="modalOptions.students"
                        stacked
                        size="lg"
                        @change="updateModalData()">
                </b-form-checkbox-group>
                <p v-else><i>Nejprve musíte vyplnit druh akce...</i></p>
            </div>
            <hr>
            <b-form-group>
                <label>Popis aktivity</label>
                <b-form-textarea
                        id="form-description"
                        v-model="modalData.description"
                        placeholder="Popis aktivity..."
                        rows="3"
                        max-rows="6"
                        @change="updateModalData()"
                ></b-form-textarea>
            </b-form-group>
            <b-form-group class="text-left mt-5">
                <b-button variant="danger" size="sm"  @click="deleteItem(modalData.id)">Smazat
                    <b-icon icon="trash-fill" ></b-icon>
                </b-button>
            </b-form-group>


            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-edit')">Zavřít</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';
    import Navbar from "../components/navbar";
    import MessageController from "../components/message-controller";

    export default {
        name: "attendance-sheet",
        components: { MessageController, Navbar},
        data() {
            return {
                posts: [],
                modalData: Object,
                modalOptions: Object,
                errors: [],
                changedModalId: null,
                layoutExt: false
            }
        },
        methods: {
            async updateModalData(reload='') {
                try {
                    await axios({
                        url: process.env.VUE_APP_SERVER+'attendance-sheet/update-sheet.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        data: this.modalData,
                        method: 'PUT'
                    });

                    this.loadData();
                    this.$eventHub.$emit('openMessageController', 'success', 'Změna proběhla úspěšně');
                    if (reload == 'reload-options') {
                        this.loadModalOptions();
                    }

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }

            },

            async addNewSheet() {

                try {
                    const response = await axios({
                        url: process.env.VUE_APP_SERVER+'attendance-sheet/new-sheet.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        method: 'POST'
                    });

                    // data se načítají ve špatnou chvíli.
                    this.loadData();
                    this.openModal(response.data.id, true);


                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                }

            },

            loadData() {
                axios({
                    url: process.env.VUE_APP_SERVER+'attendance-sheet/list.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    method: 'GET'
                }).then(response_data => {
                    this.posts = response_data.data;
                }).catch(error => {
                    console.log(error.response.data.message);
                    this.$eventHub.$emit('openMessageController', 'error', 'Žádná data');
                });
            },

            loadModalOptions() {

                axios({
                    url: process.env.VUE_APP_SERVER+'attendance-sheet/modal-options.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: {'selected_course': this.selectedCourse},
                    method: 'POST'
                }).then(
                    response_data => {
                        this.modalOptions = response_data.data;
                    }
                )
            },

            openModal(itemId, newItem=false) {
                this.changedModalId = itemId;
                this.$bvModal.show('modal-edit'); // open bs modal

                if (!newItem) {
                    this.changeDataInModal(itemId);
                } else {
                    this.modalData = {
                        id: itemId,
                        description: null,
                        name: null,
                        name_custom: null,
                        usersSelected: [],
                        studentsSelected: [],
                        time: '2:00',
                        date: {date: moment().format('YYYY-MM-DD')}

                    };
                }
                this.loadModalOptions();
            },

            async deleteItem(id) {
                try {
                    if (confirm("Opravdu smazat?")) {
                        await axios({
                            url: process.env.VUE_APP_SERVER + 'attendance-sheet/delete-item.php',
                            headers: {'content-type': 'application/x-www-form-urlencoded'},
                            data: {'id': id},
                            method: 'DELETE'
                        });

                        this.$bvModal.hide('modal-edit');
                        this.loadData();
                        this.$eventHub.$emit('openMessageController', 'success', 'Položka byla smazána');
                    }

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }

            },

            changeDataInModal(itemId) {
                this.modalData = this.posts.courses.find( ({ id }) => id === itemId );
                this.modalData.usersSelected = Array.from(this.modalData.users, x => x.id); // z users se udělá obyčejné pole hodnot (users id)
                this.modalData.studentsSelected = Array.from(this.modalData.students, x => x.id); // z users se udělá obyčejné pole hodnot (users id)
            },
        },
        computed: {
            selectedCourse: function () {
                if (this.modalData.id_courses) {

                    return this.modalData.id_courses;
                } else {
                    return '';
                }

            }
        },
        mounted() {
            this.loadData();
        },
    }
</script>

<style lang="scss" scoped>
    .table {
        max-width: 100%;
        th, td {
            padding-left: 0;
            padding-right: 0;
        }
        tr.no-border-row {
            td {
                border: none;
            }
        }
    }

    .icons {
        font-size: 1.5rem;
        float: right;
        cursor: pointer;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .b-icon {
            &:hover {
                transform: scale(1.05);
                transition: transform 100ms linear;
            }
        }
    }

</style>

<style lang="scss" >
    .courses-radio-btn.btn-group {
        flex-wrap: wrap;
        > .btn {
            margin-right: 2px;
            margin-bottom: 2px;
        }
    }

    .custom-control.custom-checkbox {
        margin-bottom: 5px;
    }

    .students-group {
        column-count: 2;
        column-gap: 2px;
    }



</style>
